import { observer } from 'mobx-react-lite';
import { ImageUploader } from '../../inputs/image-uploader/image-uploader';
import { PopupStore } from '../popup.store';

export const ProfileImageUpdater = observer<{
  popupStore: PopupStore;
  styles: { [key: string]: string };
}>(
  ({
    popupStore,
    styles,
  }: {
    popupStore: PopupStore;
    styles: { [key: string]: string };
  }) => {
    return (
      <>
        <div className="row">
          <div className={`text-regular`}>
            <div className={styles.headingBannerContainer}>
              <div className={styles.profileIcon}>
                <i className="icon-profile"></i>
              </div>
              <h3 className={styles.profileHeading}>Edit Profile Image</h3>
              <p className={styles.subHeader}>
                Position your image in the circle, you can scroll your mouse
                wheel or pinch to zoom in or out, when you're happy click save
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <ImageUploader
            onSubmit={(value: string) => {
              popupStore.changeSelectedImage(value);
              popupStore.onAction();
            }}
            onCancel={() => {
              popupStore.defaultClose();
            }}
          ></ImageUploader>
        </div>
      </>
    );
  }
);